<template>
    <views class="base-info">
        <nav-bar
            :title="moduleTitle"
            @click-left="onClickLeft">
        </nav-bar>
        <views v-if="!isEdit">
            <div style="position:relative;">
                <edit-img :avatar="form.avatar"></edit-img>
            </div>
            <views class="line"></views>
            <views class="base-info-content">
                <views class="base-info-list" @click="handleEdit('真实姓名','real_name')">
                    <views class="base-info-label">真实姓名</views>
                    <views class="base-info-value">{{ member.real_name }}</views>
                    <views class="base-info-arrow">
                        <images :src="arrow"></images>
                    </views>
                </views>
                <views class="base-info-list">
                    <views class="base-info-label">昵称</views>
                    <views class="base-info-value">{{ member.nick_name }}</views>
                    <views class="base-info-arrow none">
                        <images :src="arrow"></images>
                    </views>
                </views>
                <views class="base-info-list"  @click="handleEdit('手机号码','phone')">
                    <views class="base-info-label">电话</views>
                    <views class="base-info-value">{{ member.mobile }}</views>
                    <views class="base-info-arrow">
                        <images :src="arrow"></images>
                    </views>
                </views>
                <views class="base-info-list"  @click="handleEdit('身份认证','id_card')">
                    <views class="base-info-label">身份认证</views>
                    <views class="base-info-value">{{is_real_name?'已认证':'未认证'}}</views>
                    <views class="base-info-arrow">
                        <images :src="arrow"></images>
                    </views>
                </views>
                <views class="base-info-list"  @click="handleEdit('收件地址','address')">
                    <views class="base-info-label">收件地址</views>
                    <views class="base-info-value">{{ member.address.address }}</views>
                    <views class="base-info-arrow">
                        <images :src="arrow"></images>
                    </views>
                </views>
            </views>
        </views>
        <views v-else>
            <views v-if="currentEdit==='address'">
                 <views class="base-info-list">
                    <views class="base-info-value" @click="onSelectArea">
                        <input type="text"  v-model="areaShow" readonly placeholder="请选择地址">
                    </views>
                </views>
                 <views class="base-info-list">
                    <views class="base-info-value">
                        <input type="text" v-model="address" placeholder="请输入详细地址">
                    </views>
                </views>
            </views>
            <views v-else-if="currentEdit === 'id_card'">
                 <views class="base-info-value">
                    <input type="text" placeholder="请输入真实姓名" v-model="form['real_name']">
                </views>
                <views class="base-info-value">
                    <input type="text" placeholder="请输入省份证号码" v-model="form[currentEdit]">
                </views>
            </views>
            <div v-else>
                 <views class="base-info-value">
                    <input type="text" placeholder="请输入" v-model="form[currentEdit]">
                </views>
            </div>
            <views class="base-info-button">
                <button class="primary" @click="save">保存</button>
            </views>
        </views>
        <select-area ref="selectArea" :show-area="showArea" @cancel="showArea=false" @confirm="onConfirm"/>
    </views>
</template>

<script>
import EditImg from './EditImg'
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
import storage from '@/utils/storage'
import SelectArea from '../../components/selectArea'
export default {
    components: {
        NavBar,
        EditImg,
        SelectArea
    },
    mixins: [tools],
    data() {
        return {
            moduleTitle: '基本信息',
            arrow: require('@/assets/images/awr.png'),
            form: {
                mobile: '',
                real_name: ''
            },
            currentEdit: 'real_name',
            member: {},
            isEdit: false,
            showArea: false,
            area: {},
            areaShow: '',
            address: '',
            is_real_name: false
        }
    },
    created() {
        this.setUserInfo()
    },
    methods: {
        onSelectArea() {
            this.showArea = true
        },
        onConfirm(city) {
            console.log(city)
            this.area = {
                province_id: city[0].code,
                city_id: city[1].code,
                district_id: city[2].code,
                address: this.address
            }
            this.areaShow = `${city[0].name}-${city[1].name}-${city[2].name}`
        },
        onClickLeft() {
            if (this.isEdit) {
                this.isEdit = false
                this.moduleTitle = '基本信息'
            } else {
                this.push('/person')
            }
        },
        handleEdit(moduleTitle, model) {
            this.currentEdit = model
            this.moduleTitle = moduleTitle
            this.isEdit = true
            this.form[model] = JSON.parse(storage.get('member'))[model === 'phone' ? 'mobile' : model]
        },
        save() {
            // 保存地址
            if (this.currentEdit === 'address') {
                if (!this.area.province_id) return this.notify('请选择区域')
                if (this.address.length === 0) return this.notify('详细地址不能为空')
                this.area.address = this.address
                api.addRecivieAddrs(this.area).then(res => {
                    this.sucMsg('保存成功')
                    this.isEdit = false
                    this.member.address.address = res.data.address
                })
                return
            }
            const realName = this.trim(this.form[this.currentEdit])
            if (this.currentEdit === 'real_name') {
                if (realName.length === 0) return this.notify('真实姓名不能为空')
                if (realName.length === 12) return this.notify('真实姓名不能大于12个字符')
            } else if (this.currentEdit === 'id_card') {
                if (realName.length === 0) return this.notify('请输入身份证号码')
            } else {
                if (realName.length === 0) return this.notify('手机号码不能为空')
                if (/^1\d{10}$/g.test(realName) === false) return this.notify('手机号码不正确')
            }
            const params = { [this.currentEdit]: realName }
            console.log(this.form)
            Object.keys(this.form).forEach(key => {
                if (this.currentEdit !== key) {
                    params[key] = this.form[key]
                }
            })
            api.updateUserInfo(params).then((res) => {
                api.getUserInfo().then((res) => {
                    if (res) {
                        this.member = res.data
                        Object.keys(this.member).forEach(key => {
                            this.$set(this.member, key, this.member[key])
                        })
                        this.is_real_name = res.data.is_real_name
                        storage.set('member', JSON.stringify(res.data))
                        this.setUserInfo()
                    }
                })
                this.sucMsg('保存成功')
                this.isEdit = false
            })
        },
        setUserInfo() {
            this.member = JSON.parse(storage.get('member'))
            this.form = JSON.parse(storage.get('member'))
            Object.keys(this.form).forEach(key => {
                this.$set(this.form, key, this.form[key])
            })
            this.address = this.member.address.address
            this.is_real_name = this.member.is_real_name
            setTimeout(() => {
                const list = this.$refs.selectArea.areaList
                console.log(list, this.member.address.province_id, list[this.member.address.province_id])
                this.area = {
                    city_id: this.member.address.city_id,
                    district_id: this.member.address.district_id,
                    province_id: this.member.address.province_id
                }
                if (this.member.address.province_id !== '0' && this.member.address.city_id !== '0' && this.member.address.district_id !== '0') {
                    this.areaShow = `${list.province_list[this.member.address.province_id]}-${list.city_list[this.member.address.city_id]}-${list.county_list[this.member.address.district_id]}`
                }
            }, 400)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
.rz{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 8px;
    color:#999;
    font-size: 14px;
}
</style>
